
import { cn } from '@/lib/utils';

const TYPE_OPTIONS = [
  {
    value: 'prayer_request',
    label: 'Prayer Request',
    description: 'Ask others to pray with you',
    icon: (
      <svg
        className="w-8 h-8 text-primary-600 dark:text-primary-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
        />
      </svg>
    ),
  },
  {
    value: 'praise_report',
    label: 'Answered Prayer',
    description: 'Share how God moved in your life',
    icon: (
      <svg
        className="w-8 h-8 text-primary-600 dark:text-primary-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
        />
      </svg>
    ),
  },
] as const;

interface PrayerFormStepChooseProps {
  value: string;
  onSelectType: (value: string) => void;
}

export function PrayerFormStepChoose({ value, onSelectType }: PrayerFormStepChooseProps) {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 gap-6"
      role="radiogroup"
      aria-label="What would you like to share?"
    >
      {TYPE_OPTIONS.map((option) => {
        const isSelected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            onClick={() => onSelectType(option.value)}
            className={cn(
              'group rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 flex flex-col items-center justify-center gap-3 shadow-sm hover:shadow-md transition-shadow text-center',
              'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2'
            )}
          >
            <span className="flex items-center justify-center w-12 h-12 rounded-full bg-primary-50 dark:bg-primary-900/30">
              {option.icon}
            </span>
            <span className="text-lg font-semibold text-slate-900 dark:text-white">
              {option.label}
            </span>
            <span className="text-sm text-slate-500 dark:text-slate-400">{option.description}</span>
          </button>
        );
      })}
    </div>
  );
}
